import { render, staticRenderFns } from "./AddRecord.vue?vue&type=template&id=a6ba6be4&scoped=true"
import script from "./AddRecord.vue?vue&type=script&lang=js"
export * from "./AddRecord.vue?vue&type=script&lang=js"
import style0 from "./AddRecord.vue?vue&type=style&index=0&id=a6ba6be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ba6be4",
  null
  
)

export default component.exports